// Shopify Forms Styling
(function() {
    // Configuration: Check every 500ms, stop trying after 15 seconds
    const CHECK_INTERVAL = 500;
    const TIMEOUT = 15000; 
    let timeElapsed = 0;

    const intervalId = setInterval(function() {
        const appEmbed = document.querySelector('shopify-forms-embed');

        if (appEmbed && appEmbed.shadowRoot) {
        
        const internalForm = appEmbed.shadowRoot.querySelector('[role="dialog"]');
        
        if (internalForm) {
            // Style element
            const sheet = document.createElement('style');
            sheet.innerHTML = `
                [role="dialog"] > div:last-child {
                    background-color: #F1582A;
                    padding: 35px !important;
                    border: 17px solid #F1582A !important; 
                    border-radius: 10px !important;
                }
            `;

            // Inject styles
            appEmbed.shadowRoot.appendChild(sheet);
            clearInterval(intervalId);
            console.log('Custom Shopify Form styles applied successfully.');
        }
        }

        // Stop checking after the timeout period to save resources
        timeElapsed += CHECK_INTERVAL;
        if (timeElapsed >= TIMEOUT) {
        clearInterval(intervalId);
        }

    }, CHECK_INTERVAL);
})();